import React, { createContext, useState, useEffect } from 'react';

export const ProjectContext = createContext();

export const ProjectProvider = ({ children }) => {
  const [projects, setProjects] = useState([]);
  const [projectsloading, setProjectsLoading] = useState(true);

  const fetchProjects = async (userId = null) => {
    try {
      setProjectsLoading(true);
      const query = userId ? `?user_id=${userId}` : '';
      const res = await fetch(`/api/projects${query}`);
      const text = await res.text();
      console.log("Проекты: статус", res.status, "тело:", text);

      if (!res.ok) {
        setProjects([]);
        return;
      }

      const data = JSON.parse(text);
      if (data && Array.isArray(data.projects)) {
        setProjects(data.projects);
      } else {
        console.warn("⚠️ Ответ не массив", data);
        setProjects([]);
      }
    } catch (err) {
      console.error('Ошибка загрузки проектов:', err);
      setProjects([]);
    } finally {
      setProjectsLoading(false);
    }
  };
  

  useEffect(() => {
    fetchProjects();
  }, []);

  return (
    <ProjectContext.Provider value={{ projects, setProjects, fetchProjects, projectsloading }}>
      {children}
    </ProjectContext.Provider>
  );
};
